import { PatientInfo } from '../views/types'
import BridgeHelper, { PatientInApp } from './bridgeHelper'
import {
	dataForEthnicity,
	dataForGender,
	dataForMartialStatus, dataForNotificationPreference,
	dataForPreferenceLanguage, dataForRace,
	dataForState,
} from '../views/datasource'
import moment from 'moment'

const updatePatientInfoWithPatientInApp = (info: PatientInfo, patient: PatientInApp) => {
	const parseGender = (gender: string) => {
		const item = dataForGender.find((item) => item.value.toUpperCase() === gender.toUpperCase())
		return item || dataForGender[0]
	}
	const parseState = (state: string) => {
		const item = dataForState.find((item) => item.value.toUpperCase() === state.toUpperCase())
		return item || dataForState[0]
	}
	const parseMarriageStatus = (status: string) => {
		const item = dataForMartialStatus.find((item) => item.value.toUpperCase() === status.toUpperCase())
		return item || dataForMartialStatus[0]
	}
	const parseLanguage = (language: string) => {
		const item = dataForPreferenceLanguage.find((item) => item.name.toUpperCase() === language.toUpperCase())
		return item || dataForPreferenceLanguage[0]
	}
	const parseEthnicity = (ethnicity: string) => {
		const item = dataForEthnicity.find((item) => `${item.raceCode || ""}->${item.name || ""}`.toUpperCase() === ethnicity.toUpperCase())
		return item || dataForEthnicity[0]
	}
	const parseRace = (race: string) => {
		const item = dataForRace.find((item) => `${item.raceCode || ""}->${item.name || ""}`.toUpperCase() === race.toUpperCase())
		return item || dataForRace[0]
	}
	const parseContact = (contact: string) => {
		const item = dataForNotificationPreference.find((item) => item.value.toString() === contact.toString())
		return item || dataForNotificationPreference[0]
	}

	info.patientFirstName = patient.firstName
	info.patientLastName = patient.lastName
	info.patientDOB = patient.dob ? moment(patient.dob, "MM/dd/YYYY").format("YYYY-MM-DD") : ""
	info.patientAddrStreet = patient.address
	info.patientAddrCity = patient.city
	info.patientAddrZip = patient.zip
	info.patientMobilePhone = patient.phone
	info.patientEMail = patient.email
	info.patientGender = parseGender(patient.gender)
	info.patientAddrState = parseState(patient.state)
	info.patientMarrage = parseMarriageStatus(patient.maritalStatus)
	info.language = parseLanguage(patient.language)
	info.ethnicity = parseEthnicity(patient.ethnicity)
	info.race = parseRace(patient.race)
	info.contactMethod = parseContact(patient.notification)
	BridgeHelper.logInfo("xxxxx: ", info)
	return info
}

export {
	updatePatientInfoWithPatientInApp,
}
